var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'code_button':true, 'disabled': _vm.btnDisabled || _vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.mainValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }